module.exports = __webpack_public_path__ + "staticVue/img/logoDv.2d7a8d6f.png";